import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { UserService } from './user.service';
import { Observable, of } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  canProceed: boolean = false;
  constructor(
    private userService: UserService
  ) { }
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.userService.authenticated()) {
      const permissions = route.data && route.data.permissions ? route.data.permissions as Array<string> : null;
      if (permissions) {
        // Implement the Role checking logic here.  return of(true) if permission exist. else return of(false)
        return of(true);
      } else {
        return of(true);
      }
    } else {
      return of(true);
    }

  }

}